import React from 'react'
import Logo1 from "../../../../src/assets/TimeLineLogo/Logo1.svg"
import Logo2 from "../../../../src/assets/TimeLineLogo/Logo2.svg"
import Logo3 from "../../../../src/assets/TimeLineLogo/Logo3.svg"
import Logo4 from "../../../../src/assets/TimeLineLogo/Logo4.svg"
import TimelineImage from "../../../../src/assets/Images/TimelineImage.png" 
const timeline=[
    {
        logo:Logo1,
        heading:"Leadership",
        description:"Fully committed to the success company",
    },

    {
        logo:Logo2,
        heading:"Responsibility",
        description:"Students will always be our top priority"
    },

    {
        logo:Logo3,
        heading:"Flexibility",
        description:"The ability to switch is an important skills"
    },

    {
        logo:Logo4,
        heading:"Solve the problem",
        description:"Code your way to a solution"
    }
]

const TimeLineLanguage = () => {

  return (
    <div>
         <div className='flex flex-row items-center gap-15'>
            <div className='w-[45%] flex flex-col gap-5'>
                {
                    timeline.map((element,index)=>{
                        return (
                        <div className='flex flex-row gap-6 relative' key={index}>
                            <div className='w-[50px] h-[50px] bg-white flex items-center'>
                               <img src={element.logo} ></img>
                            </div>
           
                            <div>
                                <p className='font-semibold text-[18px]'>{element.heading}</p>
                                <p>{element.description}</p>
                            </div>
                        </div>
                        )
                    })
                }
            </div>

            <div className='relative shadow-blue-200'>
                <img src={TimelineImage} className='shadow-white object-cover h-fit'></img>
                <div className='absolute bg-caribbeangreen-700 flex flex-row text-white uppercase py-7
                            left-[50%] translate-x-[-50%] translate-y-[-65%]'>
                     <div className='flex flex-row gap-5 items-center border-r border-caribbeangreen-300 px-7'>
                        <p className='text-3xl font-bold'>10</p>
                        <p className='text-caribbeangreen-300 text-sm'>YEARS EXPERIENCES</p>
                     </div>

                     <div className='flex gap-5 items-center px-7'>
                        <p className='text-3xl font-bold'>250</p>
                        <p className='text-caribbeangreen-300 text-sm'>TYPES OF COURSES</p>
                     </div>
                </div>

            </div>
         </div>
    </div>
  )
}

export default TimeLineLanguage